import React from "react";
import Ornament from "@/components/Ornament";
import Reveal from "@/components/Reveal";

const DressCode = () => (
  <section id="dress" className="section dress" data-testid="section-dress">
    <Ornament />
    <Reveal as="h2" className="script-h2">
      Dress Code
    </Reveal>
    <Reveal as="p" className="lead center">
      An elegant country manor celebration
    </Reveal>
    <div className="dress-grid">
      <Reveal className="dress-col">
        <h4 className="small-caps">Gentlemen</h4>
        <p>Black Tie</p>
      </Reveal>
      <Reveal className="dress-col" delay={120}>
        <h4 className="small-caps">Ladies</h4>
        <p>Darker Hues</p>
      </Reveal>
    </div>
  </section>
);

export default DressCode;
